'use strict';

var clientSso = require('@aws-sdk/client-sso');



Object.defineProperty(exports, "GetRoleCredentialsCommand", {
	enumerable: true,
	get: function () { return clientSso.GetRoleCredentialsCommand; }
});
Object.defineProperty(exports, "SSOClient", {
	enumerable: true,
	get: function () { return clientSso.SSOClient; }
});
